// 缓存工具类
class CacheManager {
  constructor() {
    this.cacheKeys = {
      // 站点信息缓存
      STATIONS: 'busStation_stations',
      LINE_NAME: 'busStation_lineName',
      LINE_TYPE: 'busStation_lineType',
      CURRENT_DIRECTION: 'busStation_currentDirection',
      
      // 音频播放列表缓存
      AUDIO_SEQUENCES: 'busStation_audioSequences',
      SEPARATE_DIRECTIONS: 'busStation_separateDirections',
      
      // 语言设置缓存
      LANGUAGE_SETTINGS: 'busStation_languageSettings',
      
      // 音频文件夹路径缓存
      AUDIO_FOLDERS: 'busStation_audioFolders',
      
      // 模板设置缓存
      TEMPLATES: 'busStation_templates',
      
      // LED设置缓存
      LED_SETTINGS: 'ledSettings'
    };
  }

  // 保存站点信息
  saveStations(upDirectionStations, downDirectionStations) {
    try {
      const stationsData = {
        upDirection: upDirectionStations,
        downDirection: downDirectionStations,
        timestamp: Date.now()
      };
      localStorage.setItem(this.cacheKeys.STATIONS, JSON.stringify(stationsData));
      console.log('站点信息已缓存');
    } catch (error) {
      console.error('保存站点信息失败:', error);
    }
  }

  // 加载站点信息
  loadStations() {
    try {
      const cached = localStorage.getItem(this.cacheKeys.STATIONS);
      if (cached) {
        const data = JSON.parse(cached);
        // 检查缓存是否过期（7天）
        if (Date.now() - data.timestamp < 7 * 24 * 60 * 60 * 1000) {
          console.log('从缓存加载站点信息');
          return {
            upDirection: data.upDirection || [],
            downDirection: data.downDirection || []
          };
        } else {
          console.log('站点信息缓存已过期');
          this.clearStations();
        }
      }
    } catch (error) {
      console.error('加载站点信息失败:', error);
      this.clearStations();
    }
    return { upDirection: [], downDirection: [] };
  }

  // 保存线路基本信息
  saveLineInfo(lineName, lineType, currentDirection) {
    try {
      const lineData = {
        lineName: lineName || '',
        lineType: lineType || 'twoWay',
        currentDirection: currentDirection || 'up',
        timestamp: Date.now()
      };
      localStorage.setItem(this.cacheKeys.LINE_NAME, JSON.stringify(lineData));
      console.log('线路信息已缓存');
    } catch (error) {
      console.error('保存线路信息失败:', error);
    }
  }

  // 加载线路基本信息
  loadLineInfo() {
    try {
      const cached = localStorage.getItem(this.cacheKeys.LINE_NAME);
      if (cached) {
        const data = JSON.parse(cached);
        if (Date.now() - data.timestamp < 7 * 24 * 60 * 60 * 1000) {
          console.log('从缓存加载线路信息');
          return {
            lineName: data.lineName || '',
            lineType: data.lineType || 'twoWay',
            currentDirection: data.currentDirection || 'up'
          };
        } else {
          console.log('线路信息缓存已过期');
          this.clearLineInfo();
        }
      }
    } catch (error) {
      console.error('加载线路信息失败:', error);
      this.clearLineInfo();
    }
    return {
      lineName: '',
      lineType: 'twoWay',
      currentDirection: 'up'
    };
  }

  // 保存音频播放列表
  saveAudioSequences(audioData) {
    try {
      const audioSequencesData = {
        // 默认音频序列
        defaultArrivalAudioSequence: audioData.defaultArrivalAudioSequence || [],
        defaultDepartureAudioSequence: audioData.defaultDepartureAudioSequence || [],
        welcomeAudioSequence: audioData.welcomeAudioSequence || [],
        terminalAudioSequence: audioData.terminalAudioSequence || [],
        
        // 上下行音频序列
        upArrivalAudioSequence: audioData.upArrivalAudioSequence || [],
        downArrivalAudioSequence: audioData.downArrivalAudioSequence || [],
        upDepartureAudioSequence: audioData.upDepartureAudioSequence || [],
        downDepartureAudioSequence: audioData.downDepartureAudioSequence || [],
        upWelcomeAudioSequence: audioData.upWelcomeAudioSequence || [],
        downWelcomeAudioSequence: audioData.downWelcomeAudioSequence || [],
        upTerminalAudioSequence: audioData.upTerminalAudioSequence || [],
        downTerminalAudioSequence: audioData.downTerminalAudioSequence || [],
        
        // 服务语音频序列
        serviceAudioSequences: audioData.serviceAudioSequences || [],
        
        // 上下行分离设置
        separateDirections: audioData.separateDirections || {
          arrival: false,
          departure: false,
          welcome: false,
          terminal: false
        },
        
        timestamp: Date.now()
      };
      localStorage.setItem(this.cacheKeys.AUDIO_SEQUENCES, JSON.stringify(audioSequencesData));
      console.log('音频播放列表已缓存');
    } catch (error) {
      console.error('保存音频播放列表失败:', error);
    }
  }

  // 加载音频播放列表
  loadAudioSequences() {
    try {
      const cached = localStorage.getItem(this.cacheKeys.AUDIO_SEQUENCES);
      if (cached) {
        const data = JSON.parse(cached);
        if (Date.now() - data.timestamp < 7 * 24 * 60 * 60 * 1000) {
          console.log('从缓存加载音频播放列表');
          return {
            defaultArrivalAudioSequence: data.defaultArrivalAudioSequence || [],
            defaultDepartureAudioSequence: data.defaultDepartureAudioSequence || [],
            welcomeAudioSequence: data.welcomeAudioSequence || [],
            terminalAudioSequence: data.terminalAudioSequence || [],
            upArrivalAudioSequence: data.upArrivalAudioSequence || [],
            downArrivalAudioSequence: data.downArrivalAudioSequence || [],
            upDepartureAudioSequence: data.upDepartureAudioSequence || [],
            downDepartureAudioSequence: data.downDepartureAudioSequence || [],
            upWelcomeAudioSequence: data.upWelcomeAudioSequence || [],
            downWelcomeAudioSequence: data.downWelcomeAudioSequence || [],
            upTerminalAudioSequence: data.upTerminalAudioSequence || [],
            downTerminalAudioSequence: data.downTerminalAudioSequence || [],
            serviceAudioSequences: data.serviceAudioSequences || Array(10).fill().map(() => []),
            separateDirections: data.separateDirections || {
              arrival: false,
              departure: false,
              welcome: false,
              terminal: false
            }
          };
        } else {
          console.log('音频播放列表缓存已过期');
          this.clearAudioSequences();
        }
      }
    } catch (error) {
      console.error('加载音频播放列表失败:', error);
      this.clearAudioSequences();
    }
    return {
      defaultArrivalAudioSequence: [],
      defaultDepartureAudioSequence: [],
      welcomeAudioSequence: [],
      terminalAudioSequence: [],
      upArrivalAudioSequence: [],
      downArrivalAudioSequence: [],
      upDepartureAudioSequence: [],
      downDepartureAudioSequence: [],
      upWelcomeAudioSequence: [],
      downWelcomeAudioSequence: [],
      upTerminalAudioSequence: [],
      downTerminalAudioSequence: [],
      serviceAudioSequences: Array(10).fill().map(() => []),
      separateDirections: {
        arrival: false,
        departure: false,
        welcome: false,
        terminal: false
      }
    };
  }

  // 保存语言设置
  saveLanguageSettings(languageSettings) {
    try {
      const languageData = {
        ...languageSettings,
        timestamp: Date.now()
      };
      localStorage.setItem(this.cacheKeys.LANGUAGE_SETTINGS, JSON.stringify(languageData));
      console.log('语言设置已缓存');
    } catch (error) {
      console.error('保存语言设置失败:', error);
    }
  }

  // 加载语言设置
  loadLanguageSettings() {
    try {
      const cached = localStorage.getItem(this.cacheKeys.LANGUAGE_SETTINGS);
      if (cached) {
        const data = JSON.parse(cached);
        if (Date.now() - data.timestamp < 7 * 24 * 60 * 60 * 1000) {
          console.log('从缓存加载语言设置');
          return {
            enabled: data.enabled || false,
            count: data.count || 2,
            languages: data.languages || [
              { name: '中文', code: 'zh' },
              { name: '英文', code: 'en' },
              { name: '日文', code: 'ja' },
              { name: '韩文', code: 'ko' },
              { name: '俄文', code: 'ru' }
            ]
          };
        } else {
          console.log('语言设置缓存已过期');
          this.clearLanguageSettings();
        }
      }
    } catch (error) {
      console.error('加载语言设置失败:', error);
      this.clearLanguageSettings();
    }
    return {
      enabled: false,
      count: 2,
      languages: [
        { name: '中文', code: 'zh' },
        { name: '英文', code: 'en' },
        { name: '日文', code: 'ja' },
        { name: '韩文', code: 'ko' },
        { name: '俄文', code: 'ru' }
      ]
    };
  }

  // 保存音频文件夹路径
  saveAudioFolders(stationAudioFolderPath, hintAudioFolderPath) {
    try {
      const folderData = {
        stationAudioFolderPath: stationAudioFolderPath || '',
        hintAudioFolderPath: hintAudioFolderPath || '',
        timestamp: Date.now()
      };
      localStorage.setItem(this.cacheKeys.AUDIO_FOLDERS, JSON.stringify(folderData));
      console.log('音频文件夹路径已缓存');
    } catch (error) {
      console.error('保存音频文件夹路径失败:', error);
    }
  }

  // 加载音频文件夹路径
  loadAudioFolders() {
    try {
      const cached = localStorage.getItem(this.cacheKeys.AUDIO_FOLDERS);
      if (cached) {
        const data = JSON.parse(cached);
        if (Date.now() - data.timestamp < 7 * 24 * 60 * 60 * 1000) {
          console.log('从缓存加载音频文件夹路径');
          return {
            stationAudioFolderPath: data.stationAudioFolderPath || '',
            hintAudioFolderPath: data.hintAudioFolderPath || ''
          };
        } else {
          console.log('音频文件夹路径缓存已过期');
          this.clearAudioFolders();
        }
      }
    } catch (error) {
      console.error('加载音频文件夹路径失败:', error);
      this.clearAudioFolders();
    }
    return {
      stationAudioFolderPath: '',
      hintAudioFolderPath: ''
    };
  }

  // 保存模板设置
  saveTemplates(arrivalTemplate, departureTemplate) {
    try {
      const templateData = {
        arrivalTemplate: arrivalTemplate || '【当前站】到了',
        departureTemplate: departureTemplate || '前方到站，【当前站】，请准备下车',
        timestamp: Date.now()
      };
      localStorage.setItem(this.cacheKeys.TEMPLATES, JSON.stringify(templateData));
      console.log('模板设置已缓存');
    } catch (error) {
      console.error('保存模板设置失败:', error);
    }
  }

  // 加载模板设置
  loadTemplates() {
    try {
      const cached = localStorage.getItem(this.cacheKeys.TEMPLATES);
      if (cached) {
        const data = JSON.parse(cached);
        if (Date.now() - data.timestamp < 7 * 24 * 60 * 60 * 1000) {
          console.log('从缓存加载模板设置');
          return {
            arrivalTemplate: data.arrivalTemplate || '【当前站】到了',
            departureTemplate: data.departureTemplate || '前方到站，【当前站】，请准备下车'
          };
        } else {
          console.log('模板设置缓存已过期');
          this.clearTemplates();
        }
      }
    } catch (error) {
      console.error('加载模板设置失败:', error);
      this.clearTemplates();
    }
    return {
      arrivalTemplate: '【当前站】到了',
      departureTemplate: '前方到站，【当前站】，请准备下车'
    };
  }

  // 清除特定缓存
  clearStations() {
    localStorage.removeItem(this.cacheKeys.STATIONS);
  }

  clearLineInfo() {
    localStorage.removeItem(this.cacheKeys.LINE_NAME);
  }

  clearAudioSequences() {
    localStorage.removeItem(this.cacheKeys.AUDIO_SEQUENCES);
  }

  clearLanguageSettings() {
    localStorage.removeItem(this.cacheKeys.LANGUAGE_SETTINGS);
  }

  clearAudioFolders() {
    localStorage.removeItem(this.cacheKeys.AUDIO_FOLDERS);
  }

  clearTemplates() {
    localStorage.removeItem(this.cacheKeys.TEMPLATES);
  }

  // 清除所有缓存
  clearAllCache() {
    Object.values(this.cacheKeys).forEach(key => {
      localStorage.removeItem(key);
    });
    // 确保清除LED设置（兼容旧版本）
    localStorage.removeItem('ledSettings');
    console.log('所有缓存已清除');
  }

  // 检查是否有缓存数据
  hasCachedData() {
    return Object.values(this.cacheKeys).some(key => {
      return localStorage.getItem(key) !== null;
    });
  }

  // 获取缓存统计信息
  getCacheStats() {
    const stats = {};
    Object.entries(this.cacheKeys).forEach(([name, key]) => {
      const data = localStorage.getItem(key);
      if (data) {
        try {
          const parsed = JSON.parse(data);
          stats[name] = {
            exists: true,
            timestamp: parsed.timestamp,
            age: Date.now() - parsed.timestamp
          };
        } catch (error) {
          stats[name] = { exists: true, error: '解析失败' };
        }
      } else {
        stats[name] = { exists: false };
      }
    });
    return stats;
  }
}

// 创建单例实例
const cacheManager = new CacheManager();

export default cacheManager; 